export default {
  create_title: 'Tilføj webhook-endpoint',
  edit_title: 'Rediger webhook-endpoint',
  form: {
    url: 'HTTPS-endpoint-URL',
    description: 'Beskrivelse',
    description_placeholder: 'f.eks. Ordrehændelser til kassesystemet',
    events: 'Hændelser, der skal leveres',
    events_required: 'Vælg mindst én hændelse.',
    events_hint: 'Kun de valgte hændelser leveres til dette endpoint.',
    events_selected: '{{selected}} af {{total}}',
    event_groups: {
      order: 'Ordrer',
      store: 'Butik',
      product: 'Produkter',
      modifier: 'Tilvalg',
      menu_push: 'Menu-push',
      payout: 'Udbetalinger',
    },
    status: 'Status',
    status_active: 'Aktiv',
    status_disabled: 'Deaktiveret',
    status_auto_disabled: 'Automatisk deaktiveret (vælg Aktiv for at genaktivere)',
  },
  buttons: {
    cancel: 'Annuller',
    create: 'Opret',
    save: 'Gem',
  },
  toasts: {
    created: 'Endpoint oprettet.',
    updated: 'Endpoint opdateret.',
    error: 'Endpointet kunne ikke gemmes. Prøv igen.',
  },
};
